<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow" v-loading="updateloading">

      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
              <el-input placeholder="业务员名称 / 业务员编码 / 组织码" v-model="query.key" @keyup.enter.native="getlists"  @change="ischange=true" clearable></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" circle @click="getlists"></el-button>
              <!--
              <el-tooltip class="item" effect="dark" content="点击同步更新金蝶的公司组织业务员信息" placement="top">
                  <el-button type="danger" icon="el-icon-setting" circle @click="updateseller"></el-button>
              </el-tooltip>
              -->
              <el-button type="danger" icon="el-icon-plus" circle  @click="addcustomersinfos"></el-button>
          </el-form-item>
      </el-form>

      <el-tag type="danger" size="small" style="margin-top:10px">警告：因金蝶软件或系统信息在修改数据时不会主动同步至另一方，如其中一方有相应的数据发生修改时，请手动同步至另一方，否则将影响同步销售订单或者采购订单的数据同步</el-tag>


      <!-- 数据信息列表 -->
      <div class="backborder2" style="margin-top:10px">
      <el-table :data="sellers" ref="multipleTable" style="width:100%;margin-top:10px" v-loading="loading" tooltip-effect="dark">
          <el-table-column label="id" prop="id" width="90"/>
          <el-table-column label="金蝶业务员名称" prop="name" />
          <el-table-column label="是否已绑定宠赞销售员" prop="ismatch" align="center" width="170"/>
          <el-table-column label="金蝶业务员编码" prop="code" align="center" width="120"/>
          <el-table-column label="所属金蝶组织码" prop="orgnzcode" align="center" width="120"/>
          <el-table-column label="操作" align="center" width="120">
		      <template slot-scope="scope">
                  <el-button type="primary" icon="el-icon-edit" size="mini" circle  @click="getkingdeeseller(scope.row)"></el-button>
				  <el-button type="warning" icon="el-icon-edit" size="mini" circle  @click="editorder(scope.row)"></el-button>
			  </template>
		  </el-table-column>
      </el-table>
      <div class="block">
	      <!--分页begin-->
	      <el-pagination
		        @size-change="pageSizeChange"
		        @current-change="pageCurrentChange"
		        :current-page="query.p"
		        :page-sizes="[10, 20, 50]"
		        :page-size="query.rollpage"
		        layout="total, sizes, prev, pager, next, jumper"
		        :total="total_rows">
	      </el-pagination>
	      <!--分页end-->
	    </div>
      </div>


      <!-- 编辑关联销售员信息 -->
      <el-dialog title="设置匹配销售员信息" :visible.sync="settingDialog" width="35%" top="10vh">
          <el-form :inline="true" class="demo-form-inline" size="small">
            <el-form-item>
              <el-select v-model="settingquery.sellerids" clearable filterable remote multiple placeholder="选择匹配宠赞销售员">
                  <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select> 
            </el-form-item>
          </el-form>	
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="settingDialog = false" style="margin-top:20px">取 消</el-button>
              <el-button size="small" type="danger" @click="savematchseller" style="margin-top:20px">确定</el-button>
          </div>    
      </el-dialog>

      <!-- 新增金蝶客户信息 -->
      <el-dialog title="新增 / 编辑金蝶业务员信息" :visible.sync="addcustomersDialog" width="30%" top="10vh">
          <el-form :inline="true" class="demo-form-inline" size="small">
              <el-form-item label="金蝶业务员名称" label-width="120">
                  <el-input placeholder="请输入金蝶销售员名称" v-model="addcustomers.name" clearable></el-input>
              </el-form-item>
              <el-form-item label="金蝶业务员编码" label-width="120">
                  <el-input placeholder="请输入金蝶销售员编码" v-model="addcustomers.code" clearable></el-input>
              </el-form-item>
              <!--
              <el-form-item label="销售员所属组织码" label-width="140">
                  <el-input placeholder="请输入销售员组织码" v-model="addcustomers.orgnzcode" clearable></el-input>
              </el-form-item>
              -->
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addcustomersDialog = false" style="margin-top:20px">取 消</el-button>
              <el-button size="small" type="danger" @click="saveaddcustomer" style="margin-top:20px">确定</el-button>
          </div> 
      </el-dialog>

  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Kingdee/index",
      transitionshow:true,
      actionauth:'',
      warns:true,
      querychange:false,
      query: {
        act:'getsellerlists',
        token:this.$cookies.get('token'),
        key:'',
        p:1,
        rollpage:10
      },
      rows:0,
      loading:false,
      ischange:false,
      total_rows:0,
      sellers:[],
      updateloading:false,

      settingDialog:false,
      settingquery: {
        act:'updatesellercontact',
        token:this.$cookies.get('token'),
        id:'',
        sellerid:'',
        sellerids:[],
      },
      sellerlists:[],
      sellerloading:false,
      addcustomers: {
        act:'addkingdeeseller',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        code:'',
        orgnzcode:'',
      },
      addcustomersDialog:false,

    }
  },

  mounted(){  
  	this.getactionauth(); //获取权限设置
    this.getlists(); //获取客户信息
    this.getSeller(); //获取销售员信息列表
  },

  methods: {

    /** 获取操作功能权限 **/
  	getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
        this.actionauth=data;
    },


    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));	                      
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },


    /** 更新客户信息 **/
    updateseller() {
      this.updateloading=true;
      var resource = this.$resource(this.url);
      resource.query({ act:'updateseller',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.updateloading=false;
          }else{
              this.updateloading=false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.updateloading=false;
      }); 
    },

    /** 获取金蝶客户信息列表 **/
    getlists() {
      this.loading=true;
      this.customers=[];
      if(this.ischange==true) {
        this.query.p=1;
        this.query.rollpage=10;
      }

      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.loading=false;
          }else{
              this.sellers = JSON.parse(Base64.decode(res.data.Data));
              this.total_rows=parseInt(res.data.count);
              this.loading=false;
              if(this.ischange==true) this.ischange=false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.loading=false;
      }); 
    },

    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getlists();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getlists();
    },


    /** 获取绑定的销售员信息 **/
    editorder(item) {
      this.settingquery.id=item.id;
      this.settingDialog=true;
      var resource = this.$resource(this.url);
      resource.query({ act:'getsellercontact',id:item.id,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.settingquery.sellerid='';
              this.settingquery.sellerids=[];
              this.settingquery.sellerids=result;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      }); 
    },

    /** 修改绑定的销售员信息 **/
    savematchseller() {
        var resource = this.$resource(this.url);
		resource.save(this.settingquery).then((res) => {
		    if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
		    }else{
			    this.getlists();
                this.settingDialog=false;
		    }
		}).catch((res) => {
		    //this.$message.error(this.GLOBAL.errortext);
		});
    },


    /** 新增金蝶客户信息 **/
    addcustomersinfos() {
        this.addcustomers.act='addkingdeeseller';
        this.addcustomers.id='';
        this.addcustomers.name=''; 
        this.addcustomers.code='';
        this.addcustomers.orgnzcode='';
        this.addcustomersDialog=true;
    },

    /** 获取金蝶客户信息 **/
    getkingdeeseller(item) {
        this.addcustomers.act='editkingdeeseller';
        this.addcustomers.id=item.id;
        this.addcustomers.name=item.name; 
        this.addcustomers.code=item.code;
        this.addcustomers.orgnzcode='';
        this.addcustomersDialog=true;
    },


    /** 保存金蝶客户信息 **/
    saveaddcustomer() {
        var resource = this.$resource(this.url);
		    resource.save(this.addcustomers).then((res) => {
		        if(res.data.Result>0){
			          if(res.data.Result=='70001') this.$router.push('/login')
			          this.$message.error(res.data.Message);
		        }else{
			          this.getlists();
                this.addcustomersDialog=false;
		        }
		    }).catch((res) => {
		        //this.$message.error(this.GLOBAL.errortext);
		    });
    },




  },

  components:{
    
  }
}
</script>
<style>
.customerkingdee,.customercz {float:left;width:100%}
.customerkingdee,.customercz {float:left;width:100%}
.customerkingdee p,.customercz p {float:left;width:100%;font-size:14px;line-height:14px}
.customerkingdee .number,.customerkingdee .compny,.customercz .number,.customercz .compny {float:left;width:100%;margin-bottom:10px}
.customerkingdee .number i,.customercz .number i  {float:left;font-style:normal;margin-right:5px;font-size:12px;color:#fff;line-height:12px;padding:3px;border-radius:5px;background:#409EFF}
.customerkingdee .number span,.customercz .number span {float:left;font-size:12px;color:#666666;line-height:12px;margin-top:2px}
.customerkingdee .compny i,.customercz .compny i  {float:left;font-style:normal;margin-right:5px;font-size:12px;color:#fff;line-height:12px;padding:3px;border-radius:5px;background:#67C23A}
.customerkingdee .compny span,.customercz .compny span {float:left;font-size:12px;color:#666666;line-height:12px;margin-top:2px}
</style>


// WEBPACK FOOTER //
// src/components/kingdee/KDseller.vue